import { NOTIFICATION_TYPES } from "../getStockPageSectionFromNotificationType";

export const ALERT_SETTINGS_CATEGORY_POSITION = {
  INSIDER_ANALYSIS: -20,
  TECHNICAL_ANALYSIS: -10,
  MORNING_BRIEF: 0,
  FINANCIAL_ANALYSIS: 1,
  VIDEO_ANALYSIS: 2,
  COMMENTS_AND_ANALYSES: 3,
  SID_SIGNALS: 10,
  SID_ALERTS: 11,
  SID_SUMMARY: 12,
  SUPPLY_DEMAND_SIGNALS: 13,
  SUPPLY_DEMAND_ALERTS: 14,
  TREND_STRATEGY: 20,
  DEFAULT: 100
};

const ALERT_SETTINGS_CATEGORY_POSITION_BY_KEY = {
  insider_analysis_category_analysis:
    ALERT_SETTINGS_CATEGORY_POSITION.INSIDER_ANALYSIS,
  insider_analysis_category_recommendation:
    ALERT_SETTINGS_CATEGORY_POSITION.INSIDER_ANALYSIS,
  stock_analysis_category_technical_analysis:
    ALERT_SETTINGS_CATEGORY_POSITION.TECHNICAL_ANALYSIS,
  stock_analysis_category_morning_brief:
    ALERT_SETTINGS_CATEGORY_POSITION.MORNING_BRIEF,
  stock_analysis_category_financial_analysis:
    ALERT_SETTINGS_CATEGORY_POSITION.FINANCIAL_ANALYSIS,
  stock_analysis_category_video_analysis:
    ALERT_SETTINGS_CATEGORY_POSITION.VIDEO_ANALYSIS,
  stock_analysis_category_short_technical_analysis:
    ALERT_SETTINGS_CATEGORY_POSITION.COMMENTS_AND_ANALYSES,
  [NOTIFICATION_TYPES.TRANSACTION_STRATEGY_HIGHS_AND_LOWS]:
    ALERT_SETTINGS_CATEGORY_POSITION.SID_SIGNALS,
  [NOTIFICATION_TYPES.HIGHS_AND_LOWS_CORRECTION]:
    ALERT_SETTINGS_CATEGORY_POSITION.SID_ALERTS,
  [NOTIFICATION_TYPES.HIGHS_AND_LOWS_SUMMARY]:
    ALERT_SETTINGS_CATEGORY_POSITION.SID_SUMMARY,
  [NOTIFICATION_TYPES.TRANSACTION_STRATEGY_SUPPLY_DEMAND]:
    ALERT_SETTINGS_CATEGORY_POSITION.SUPPLY_DEMAND_SIGNALS,
  [NOTIFICATION_TYPES.DEMAND_ZONE]:
    ALERT_SETTINGS_CATEGORY_POSITION.SUPPLY_DEMAND_ALERTS,
  donchain_h4: ALERT_SETTINGS_CATEGORY_POSITION.TREND_STRATEGY,
  [NOTIFICATION_TYPES.TRANSACTION_STRATEGY_TREND]:
    ALERT_SETTINGS_CATEGORY_POSITION.TREND_STRATEGY
};

export function getAlertSettingsCategoryPosition(key) {
  return (
    ALERT_SETTINGS_CATEGORY_POSITION_BY_KEY[key] ??
    ALERT_SETTINGS_CATEGORY_POSITION.DEFAULT
  );
}
